// /src/components/ContainerPrices.js
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";

import "../InvoicesManagement.scss";
import CustomInput from "../../components/CustomInput";
import { toMoney } from "../../utils/toMoney";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/CustomButton";

import invoicesIcon from "../../assets/invoices.png";
import addIconLight from "../../assets/add_icon_light.png";
import searchIcon from "../../assets/search_icon.png";
import nextIcon from "../../assets/next_icon.png";
import previousIcon from "../../assets/previous_icon.png";
import saveIcon from "../../assets/save_icon.png";
import closeIcon from "../../assets/close_icon.png";
import infoIcon from "../../assets/information.png";
import printIcon from "../../assets/printer_icon.png";
import editIcon from "../../assets/edit_icon.png";

import UserSection from "../../components/UserSection";
import { DataContext } from "../../utils/DataContext";
import InformationBox from "../../components/InformationBox";
import Modal from "../../components/Modal";
import classes from "../../components/Modal.module.css";
import useLanguage from "../../utils/useLanguage";
import { sanitizeNumber } from "../../utils/sanitizeNumber";
import BackToDashboard from "../../components/BackToDashboard";
import Loader from "../../components/Loader";
import HotDropdown from "../../components/HotDropdown";
import { onlyNums } from "../../utils/OnlyNums";
import AreYouSureModal from "../../components/AreYouSureModal";
import { shouldCloseModal } from "../../utils/shouldCloseModal";
import { useReactToPrint } from "react-to-print";
import ContainerBalancePrint from "./containerBalancePrint";
import Dropdown from "../../components/Dropdown";
import SearchFilter from "../../components/SearchFilter";

const ContainerPrices = () => {
  // New state variables for the row modal
  const [selectedRow, setSelectedRow] = useState(null);
  const [showRowModal, setShowRowModal] = useState(false);

  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();

  // Handler for opening the row info modal
  const handleRowButtonClick = (row) => {
    setSelectedRow(row);
    setShowRowModal(true);
  };

  // Handler for closing the row info modal
  const handleCloseRowModal = () => {
    setSelectedRow(null);
    setShowRowModal(false);
  };

  // Add near other state declarations
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedSearchType, setSelectedSearchType] = useState({
    title: t("Date"),
    value: "date",
  });

  // Add near other constants
  const searchTypes = [
    { title: t("Date"), value: "date" },
    { title: t("amount"), value: "amount" },
  ];

  const balancePrintRef = React.useRef(null);

  const rows = [
    {
      title: "balanceBeforeUpdate",
      value: "balance",
    },
    {
      title: "containersPrices",
      value: "containersPricesInRMB",
    },
    {
      title: "balanceAfterUpdate",
      value: "balance",
    },
    {
      title: "Date",
      value: "date",
    },
    {
      title: "notes",
      value: "notes",
    },
    {
      title: "print",
      value: "print",
    },
  ];

  const [data, setData] = useState([]);
  const [newRow, setNewRow] = useState({
    balance: 0,
    containersPricesInRMB: 0,
    currentBalance: 0,
    date: new Date(),
    notes: "",
  });

  const [showAreYouSure, setShowAreYouSure] = useState(false);

  const [showInputFields, setShowInputFields] = useState(false);
  const [tempCalc, setTempCalc] = useState(0);

  const [containersCurrentPage, setContainersCurrentPage] = useState(1);
  const [containersTotalPages, setContainersTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);

  const {
    selectedSupplier,
    setSelectedSupplier,
    currentBalance,
    setCurrentBalance,
    setSupplierFields,
    suppliers,
    getSuppliers,
    handleSelectSupplier,
    error,
    setError,
    loading,
    setLoading,
    setNetworkError,
    fetchContainers,
  } = useContext(DataContext);

  const [loadingModal, setLoadingModal] = useState(false);
  const [selectedContainerStatus, setSelectedContainerStatus] = useState({
    title: "containerPrices",
    value: "containerPrices",
  });

  const balanceStyle =
    currentBalance?.value >= 0 ? "positive-value" : "negative-value";

  const fetchAllContainers = async (page) => {
    const response = await fetchContainers(page);
    const { data, pagination, currentBalance } = response?.data || {};

    setData(data);
    setContainersCurrentPage(pagination?.currentPage);
    setTotalRecords(pagination?.totalRecords);
    setContainersTotalPages(pagination?.totalPages);
    setCurrentBalance(currentBalance);
    setNewRow((prev) => {
      const lastElement = data?.[response.data.length - 1];
      return {
        ...prev,
        balance: lastElement?.currentBalance || 0,
      };
    });
  };

  const handleAttemptCancel = () => {
    setShowAreYouSure(true);
  };

  const handleCancel = () => {
    setNewRow({
      balance: 0,
      containersPricesInRMB: 0,
      currentBalance: 0,
      date: new Date(),
      notes: "",
    });
    setShowInputFields(false);
    setLoadingModal(false);
    setShowAreYouSure(false);
  };

  const handleInputChange = (e, modal) => {
    const { name, value } = e.target;

    if (modal === "supplier") {
      setSupplierFields((prev) => ({ ...prev, [name]: value }));
    } else {
      if (name === "containersPricesInRMB") {
        setTempCalc(currentBalance?.value - sanitizeNumber(value));
      }
      setNewRow((prevRow) => {
        let updatedRow = { ...prevRow, [name]: value };

        return updatedRow;
      });
    }
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setNewRow((prevRow) => ({ ...prevRow, date: new Date(date) }));
  };

  const handleAddRow = async () => {
    if (!selectedSupplier?.id) {
      setError("noSupplier");
      return;
    } else {
      if (!newRow?.containersPricesInRMB) {
        setError("noContainersPrices");
        return;
      }
      const balanceBeforeUpdate = currentBalance?.value;

      const calcCurrentBalance =
        // currentBalance?.value - newRow?.containersPricesInRMB;
        currentBalance?.value - sanitizeNumber(newRow?.containersPricesInRMB);

      setCurrentBalance((prev) => ({ ...prev, value: calcCurrentBalance }));
      setNewRow((prev) => ({ ...prev, currentBalance: calcCurrentBalance }));

      try {
        const token = localStorage.getItem("token");
        const userId = parseInt(localStorage.getItem("userId"), 10);

        if (!userId) {
          console.error("User ID not found in localStorage");
          return;
        }

        const data = {
          ...newRow,
          containersPricesInRMB: parseFloat(
            sanitizeNumber(newRow?.containersPricesInRMB)
            // newRow?.containersPricesInRMB
          ),
          currentBalance: {
            containerId: currentBalance.containerId,
            value: calcCurrentBalance,
          },
          userId,
          supplierId: selectedSupplier?.id,
          balanceBeforeUpdate,
          balanceAfterUpdate: calcCurrentBalance,

          // balance: 0,
          // containersPricesInRMB: 0,
          // currentBalance: 0,
          // date: new Date(),
          // notes: "",
        };

        setLoadingModal(true);
        const res = await axios.post(
          `${process.env.REACT_APP_URL}/createContainerPrices`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "User-Id": userId,
            },
          }
        );

        if (res.data) {
          fetchContainerPrices({ page: 1 });
          setError("");
          setShowInputFields(false);
          setNewRow((prev) => ({
            ...prev,
            containersPricesInRMB: 0,
            date: new Date(),
            notes: "",
          }));
          setTotalRecords((prev) => prev + 1);
          setLoadingModal(false);
        }
        setLoading(false);
      } catch (error) {
        setNetworkError(true);
        console.error("Error adding new invoice:", error);
        setError("addContainerFailed");
        setLoading(false);
      }
    }
  };

  const handleShowInputFields = () => {
    setShowInputFields(true);
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const handleSearch = () => {
    if (!selectedDate) {
      return data; // Return all data if no date is selected
    }

    const lowerCaseQuery = selectedDate.toLocaleDateString("en-CA"); // Format the selected date for comparison

    const filteredData = data.filter((row) => {
      return Object.values(row).some((value) => {
        if (
          typeof value === "string" &&
          value.toLowerCase().includes(lowerCaseQuery)
        ) {
          return true; // Match found in string values
        }

        // Check if the value is a date
        const dateValue = new Date(value);
        if (!isNaN(dateValue)) {
          // Format the date to a comparable format (e.g., YYYY-MM-DD)
          const formattedDate = dateValue.toISOString().split("T")[0];
          return formattedDate.includes(lowerCaseQuery); // Check if the formatted date matches
        }

        return false; // Return false for non-matching fields
      });
    });

    return filteredData;
  };

  const fetchContainerPrices = async (params = {}) => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      const organizationId = localStorage.getItem("organizationId");

      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/containerPrices`,
        {
          params: {
            page: params.page || containersCurrentPage || 1,
            limit: params.limit || 5,
            startDate: startDate || null,
            endDate: endDate || null,
            minAmount: minAmount || null,
            maxAmount: maxAmount || maxAmount,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
            "Organization-Id": organizationId,
            "Supplier-Id": params.supplierId || selectedSupplier?.id,
          },
        }
      );

      if (response.status === 200) {
        const pagination = response.data?.pagination;
        setTotalRecords(pagination?.totalRecords);
        setContainersTotalPages(pagination?.totalPages);
        setContainersCurrentPage(pagination?.currentPage);
        setData(response.data?.data);
        setCurrentBalance(response.data?.currentBalance);
      }

      const resCurrentSupplier = response?.data?.currentSupplier;

      // !You have to check that the currentsupplier id doesn't equal the selectedsupplier id
      // !so it doesn't cause infinite rendering cycle
      if (resCurrentSupplier && !selectedSupplier?.id) {
        setSelectedSupplier(resCurrentSupplier);
      }
      // if (resCurrentSupplier && resCurrentSupplier.id !== selectedSupplier.id) {
      //   setSelectedSupplier(resCurrentSupplier);
      // }

      return response.data;
    } catch (error) {
      console.error("Error fetching container prices:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintBalance = useReactToPrint({
    contentRef: balancePrintRef,
    pageStyle: `
    @page {
      size: A4;
      margin: 10mm;
    }
    @media print {
      body {
        padding: 50px;
      }
    }
  `,
    documentTitle: `${t("BalanceInformation")}_${
      selectedSupplier?.name || ""
    }_${new Date().toISOString().split("T")[0]}`,
  });

  useEffect(() => {
    if (selectedContainerStatus.value == "transactionsHistory")
      fetchAllContainers(containersCurrentPage);
    else fetchContainerPrices({ page: containersCurrentPage });
  }, [selectedContainerStatus, selectedSupplier, containersCurrentPage]);

  return (
    <>
      <main className="e-container">
        <div>
          <BackToDashboard
            title={t("back")}
            variant="blank"
            icon={currentDirection === "ltr" ? previousIcon : nextIcon}
            iconSize={14}
          />
        </div>

        <div className="invoice-table-container">
          <UserSection page="containerPrices" />

          <div className="under-user-section">
            <div className="page-title">{t("containers")}</div>
            <CustomButton
              elementType={Link}
              title={t("invoicesPage")}
              to="/invoiceManagement"
              icon={invoicesIcon}
            />
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              {!selectedSupplier?.id ? (
                <div className="full-w-button-container">
                  <div className="column-flex-box flex-center-center">
                    <InformationBox>{t("noSuppliersAddOne")}</InformationBox>
                    <CustomButton
                      title={t("goToSuppliersPage")}
                      minWidth={140}
                      variant="blank"
                      elementType={Link}
                      to={"/viewSuppliersPage"}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="top-action-buttons responsive-box">
                    <div className="button-group">
                      <CustomButton
                        title={t("addContainer")}
                        onClick={handleShowInputFields}
                        icon={addIconLight}
                        iconSize={20}
                      />
                    </div>

                    <section className="col title-col ">
                      <label>{t("status")}: </label>
                      <Dropdown
                        options={[
                          {
                            title: "containerPrices",
                            value: "containerPrices",
                          },
                          {
                            title: "transactionsHistory",
                            value: "transactionsHistory",
                          },
                        ]}
                        selected={selectedContainerStatus}
                        setSelected={(value) => {
                          setSelectedContainerStatus(value);
                        }}
                        thick
                      />
                    </section>
                  </div>

                  {true ? (
                    <div className="c-search-bar u-margin--bottom_500">
                      <section className="c-search-bar-label-input">
                        <label>{t("search")}: </label>
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => {
                            setSelectedDate(date);
                          }}
                          dateFormat="yyyy-MM-dd"
                          placeholderText={t("searchByDate")}
                        />
                      </section>
                      <CustomButton
                        title={t("search")}
                        onClick={handleSearch}
                        icon={searchIcon}
                        iconSize={15}
                      />
                    </div>
                  ) : (
                    <div className="o-column-row-switcher o-row--gap-size_400 o-row o-row--vertical-align_end u-margin--bottom_400">
                      <label>{t("search")}: </label>

                      {selectedSearchType.value === "date" ? (
                        <div className="o-column-row-switcher o-column--gap-size_300">
                          <div>
                            <CustomInput
                              title={t("from")}
                              type="date"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              resetSearch={() => {
                                setStartDate(null);
                              }}
                              placeholder={t("from")}
                              flex
                              thick
                            />
                          </div>
                          <div>
                            <CustomInput
                              title={t("to")}
                              type="date"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              resetSearch={() => {
                                setEndDate(null);
                              }}
                              placeholder={t("to")}
                              flex
                              thick
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="o-row o-row--gap-size_200">
                          <CustomInput
                            title={t("from")}
                            value={minAmount}
                            onChange={(e) => setMinAmount(e.target.value)}
                            placeholder={t("minAmount")}
                            resetSearch={() => {
                              setMinAmount("");
                            }}
                            type="number"
                            thick
                            flex
                          />
                          <CustomInput
                            title={t("to")}
                            value={maxAmount}
                            onChange={(e) => setMaxAmount(e.target.value)}
                            placeholder={t("maxAmount")}
                            resetSearch={() => {
                              setMaxAmount("");
                            }}
                            type="number"
                            thick
                            flex
                          />
                        </div>
                      )}

                      <SearchFilter
                        options={searchTypes}
                        selected={selectedSearchType}
                        setSelected={(type) => {
                          setSelectedSearchType(type);
                          // Clear filters when switching types
                          setStartDate(null);
                          setEndDate(null);
                          setMinAmount("");
                          setMaxAmount("");
                        }}
                        thick
                      />

                      <CustomButton
                        title={t("search")}
                        onClick={fetchContainerPrices}
                        icon={searchIcon}
                        iconSize={15}
                      />
                    </div>
                  )}

                  {data.length !== 0 ? (
                    <>
                      <TableContainer component={Paper}>
                        <Table className="c-table">
                          <TableHead>
                            <TableRow>
                              {rows.map((row, index) => {
                                if (row.title === "containersPrices") {
                                  return (
                                    <TableCell
                                      key={index}
                                      className="bold-text  cell-title"
                                    >
                                      {t(row.title)}
                                      <br />
                                      {t("in")} {selectedSupplier?.currency}
                                    </TableCell>
                                  );
                                } else {
                                  return (
                                    <TableCell
                                      key={index}
                                      className="bold-text  cell-title"
                                    >
                                      {t(row.title)}
                                    </TableCell>
                                  );
                                }
                              })}
                            </TableRow>
                          </TableHead>

                          <TableBody className="table-body">
                            {/* These are the existing rows */}
                            {handleSearch()?.map((row, index) => (
                              <TableRow
                                key={index}
                                className={
                                  row.canceled || row.archived
                                    ? "canceled-invoice"
                                    : "updated-invoice"
                                }
                              >
                                <TableCell className="cell">
                                  <div className="o-row o-row--gap-size_400 o-row--horizontal-align_center">
                                    <div>
                                      {toMoney(row.balanceBeforeUpdate)}{" "}
                                    </div>
                                    <div>{selectedSupplier?.currency}</div>
                                  </div>
                                </TableCell>
                                <TableCell className="cell">
                                  <span
                                    className={
                                      row?.invoiceNumber
                                        ? "invoice"
                                        : "negative-value"
                                    }
                                  >
                                    {toMoney(row?.amountInSupCur)}
                                  </span>
                                </TableCell>
                                <TableCell className="cell">
                                  <div className="o-row o-row--gap-size_400 o-row--horizontal-align_center">
                                    <div>
                                      {toMoney(row?.balanceAfterUpdate)} {"  "}
                                    </div>
                                    <div>{selectedSupplier?.currency}</div>
                                  </div>
                                </TableCell>

                                <TableCell
                                  className="cell"
                                  style={{ height: "50px", minWidth: "145px" }}
                                >
                                  {row.date || row.modifiedAt
                                    ? new Date(row.date || row.modifiedAt)
                                        .toISOString()
                                        .split("T")[0]
                                    : ""}
                                </TableCell>

                                <TableCell className="notes-cell">
                                  {row.canceled === true ? (
                                    <div className="notes-cell-div">
                                      <div className="notes-cell-pair-container">
                                        <p className="notes-bold">
                                          {t("invoiceNumber")}:
                                        </p>
                                        <p>
                                          {row?.invoiceNumber.replace(
                                            /\s*Updated\s*\(\d+\)\s*$/,
                                            ""
                                          )}
                                        </p>
                                      </div>
                                      <div className="notes-cell-pair-container">
                                        <p className="notes-bold">
                                          {t("updatedOn")}:
                                        </p>
                                        <p className="notes-modifiedDate">
                                          {new Date(
                                            row?.modifiedAt
                                          )?.toLocaleDateString()}
                                        </p>
                                      </div>
                                      <p className="notes-bold">
                                        {t("otherNotes")}:
                                      </p>
                                      <p>{row?.notes}</p>
                                    </div>
                                  ) : row?.invoiceNumber ? (
                                    <div className="notes-cell-div">
                                      <div className="notes-cell-pair-container">
                                        <p className="notes-bold">
                                          {t("invoiceNumber")}:
                                        </p>
                                        <p>
                                          {row?.invoiceNumber?.replace(
                                            /\s*Updated\s*\(\d+\)\s*$/,
                                            ""
                                          )}
                                        </p>
                                      </div>
                                      <p className="notes-bold">
                                        {t("otherNotes")}:
                                      </p>
                                      <p>{row?.notes}</p>
                                    </div>
                                  ) : (
                                    <div className="notes-cell-div">
                                      <p>{row.notes}</p>
                                    </div>
                                  )}
                                </TableCell>

                                {/* New TableCell for the action button */}
                                <TableCell className="cell">
                                  <CustomButton
                                    variant="blank"
                                    title={t("ViewInfo")}
                                    onClick={() => handleRowButtonClick(row)}
                                    icon={infoIcon}
                                    iconSize={15}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <section className="pagination">
                        <div className="pagination-buttons">
                          <CustomButton
                            variant="blank"
                            title={t("previous")}
                            onClick={() => {
                              setContainersCurrentPage((prev) => prev - 1);
                            }}
                            disabled={containersCurrentPage === 1}
                            icon={
                              currentDirection === "ltr"
                                ? previousIcon
                                : nextIcon
                            }
                            iconSize={15}
                          />
                          <span className="pagination-location">
                            {t("page")}: {containersCurrentPage} -{" "}
                            {containersTotalPages}
                          </span>
                          <CustomButton
                            title={t("next")}
                            variant="blank"
                            onClick={() =>
                              setContainersCurrentPage((prev) => prev + 1)
                            }
                            disabled={
                              containersCurrentPage === containersTotalPages
                            }
                            icon={
                              currentDirection === "ltr"
                                ? nextIcon
                                : previousIcon
                            }
                            iconSize={15}
                            reverseIcon
                          />
                        </div>

                        <div className="pagination-buttons">
                          <span className="pagination-location">
                            {t("totalRecords")}: {totalRecords}
                          </span>
                        </div>
                      </section>

                      {selectedSupplier?.id !== "All" && (
                        <p className="current-balance">
                          {t("currentBalance")}:{" "}
                          <span className={balanceStyle}>
                            {toMoney(currentBalance?.value)}{" "}
                            {selectedSupplier?.currency}
                          </span>
                        </p>
                      )}
                    </>
                  ) : (
                    <InformationBox>{t("noTransactions")}</InformationBox>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </main>

      {/* Render the Printing modal */}
      {showRowModal && selectedRow && (
        <Modal
          title={t("BalanceInformation")}
          onClose={handleCloseRowModal}
          footer={
            <section className={classes.actions}>
              {selectedRow.invoiceNumber ? null : (
                <CustomButton
                  variant="blank"
                  elementType={Link}
                  title={t("edit")}
                  to={`/editContainer/${selectedRow?.id}`}
                  // onClick={handleEdit}
                  state={selectedRow}
                  icon={editIcon}
                  iconSize={18}
                />
              )}
              <CustomButton
                title={t("print")}
                onClick={handlePrintBalance}
                variant="gray"
                icon={printIcon}
                iconSize={18}
              />
            </section>
          }
        >
          <div style={{ display: "none" }}>
            <ContainerBalancePrint
              ref={balancePrintRef}
              selectedRow={selectedRow}
              selectedSupplier={selectedSupplier}
              currentDirection={currentDirection}
            />
          </div>

          <div className={classes.flexableForm}>
            {/* Supplier Information */}
            {selectedRow?.theDateOfUpdate ? (
              <span className={classes.infoUpdatedIn}>
                {t("infoUpdatedIn")}:
                {" " +
                  new Date(selectedRow?.theDateOfUpdate)
                    .toISOString()
                    .split("T")[0]}
              </span>
            ) : null}

            {/* Supplier */}
            <div className="view-user-entity">
              <p>{t("supplier")}:</p>
              <span>
                {selectedSupplier?.name || t("No supplier available")}
              </span>
            </div>

            {/* Balance Before Update */}
            <div className="view-user-entity">
              <p>{t("balanceBeforeUpdate")}:</p>
              <span>{toMoney(selectedRow?.balanceBeforeUpdate)}</span>
            </div>

            {/* Container's Prices */}
            <div className="view-user-entity">
              <p>{t("containersPrices")}:</p>
              <span>{toMoney(selectedRow?.amountInSupCur)}</span>
            </div>

            {/* Balance After Update */}
            <div className="view-user-entity">
              <p>{t("balanceAfterUpdate")}:</p>
              <span>{toMoney(selectedRow?.balanceAfterUpdate)}</span>
            </div>

            {/* Date */}
            <div className="view-user-entity">
              <p>{t("Date")}:</p>
              <span>
                {selectedRow?.date
                  ? new Date(selectedRow.date).toISOString().split("T")[0]
                  : selectedRow?.modifiedAt
                  ? new Date(selectedRow.modifiedAt).toISOString().split("T")[0]
                  : t("No date available")}
              </span>
            </div>

            {/* Notes */}
            <div className="view-user-entity">
              <p>{t("notes")}:</p>
              <span>{selectedRow?.notes || t("No notes available")}</span>
            </div>
          </div>
        </Modal>
      )}

      {showInputFields && (
        <Modal
          title="addContainer"
          onClose={handleAttemptCancel}
          error={
            error === "noContainersPrices" || error === "addContainerFailed" ? (
              <div className="error-message">{t(error)}</div>
            ) : null
          }
          footer={
            <>
              {loadingModal ? <Loader /> : null}
              <section className={classes.actions}>
                <CustomButton
                  onClick={handleAddRow}
                  title={t("confirm")}
                  icon={saveIcon}
                  iconSize={16}
                  disabled={loadingModal}
                />
                <CustomButton
                  title={t("cancel")}
                  onClick={handleAttemptCancel}
                  variant="blank"
                  icon={closeIcon}
                  iconSize={14}
                />
              </section>
            </>
          }
        >
          <div className={classes.flexableForm}>
            <section>
              {error === "noSupplier" && (
                <div className="error-message">{t(error)}</div>
              )}
              <div className={classes.inputContainer}>
                <span className={classes.longSpan}>{t("supplier")}: </span>

                <HotDropdown
                  initOptions={suppliers}
                  selected={selectedSupplier}
                  setSelected={handleSelectSupplier}
                  page="containers"
                  optionsName={"suppliers"}
                  getData={getSuppliers}
                  thick
                  flex
                  errorText={error}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={classes.longSpan}>
                  {t("balanceBeforeUpdate")}:{" "}
                </span>
                <CustomInput
                  name="balanceBeforeUpdate"
                  value={currentBalance?.value}
                  onChange={handleInputChange}
                  readOnly
                  flex={true}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={classes.longSpan}>
                  {t("containersPrices")}:{" "}
                </span>
                {/* {error === "noContainersPrices" && (
                <div className="error-message">{t(error)}</div>
              )} */}
                <CustomInput
                  name="containersPricesInRMB"
                  value={newRow?.containersPricesInRMB}
                  onChange={handleInputChange}
                  onKeyDown={(e) => onlyNums(e)}
                  type="money"
                  flex={true}
                  errorText={error === "noContainersPrices" ? t(error) : null}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={classes.longSpan}>
                  {t("balanceAfterUpdate")}:{" "}
                </span>
                <CustomInput
                  name="balanceAfterUpdate"
                  value={tempCalc || currentBalance?.value}
                  onChange={handleInputChange}
                  flex={true}
                />
              </div>
            </section>

            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={classes.longSpan}>{t("Date")}: </span>
                <CustomInput
                  type="date"
                  name="date"
                  flex={true}
                  value={
                    newRow?.date.toISOString().split("T")[0] ||
                    newRow?.modifiedAt.toISOString().split("T")[0]
                  }
                  onChange={(date) => handleDateChange(date)}
                />
              </div>
            </section>

            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={`${classes.longSpan} ${classes.notesSpan}`}>
                  {t("notes")}:{" "}
                </span>
                <CustomInput
                  name="notes"
                  type="textarea"
                  value={newRow?.notes}
                  onChange={handleInputChange}
                  flex={true}
                />
              </div>
            </section>
            {error === "noSupplier" && (
              <div className="error-message">{t(error)}</div>
            )}
          </div>
        </Modal>
      )}

      {showAreYouSure ? (
        <AreYouSureModal
          shouldCloseModal={shouldCloseModal({ ...newRow })}
          onClose={() => setShowAreYouSure(false)}
          onConfirm={handleCancel}
         confirmIconType="whiteCheck"

        />
      ) : null}
    </>
  );
};

export default ContainerPrices;
